import styled from "styled-components";

export const Container = styled.div`
  height: ${(props) => (props.$electron ? "calc(100vh - 2.2em)" : "100vh")};
  width: 100vw;
  display: flex;
`;

export const Overlay = styled.div`
  width: ${(props) =>
    props.$menuMinimized ? "calc(100% - 3.5em)" : "calc(100% - 15em)"};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 0;
  padding-bottom: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  scroll-behavior: smooth;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 1600px) {
    /* zoom removido — cria containing block que prende position:fixed */
  }
  @media (max-width: 1400px) {
    /* zoom removido */
  }
  @media (max-width: 1200px) {
    /* zoom removido */
  }
  @media (max-width: 1024px) {
    /* zoom removido */
  }

  > * {
    flex-shrink: 0;
    width: 100%;
    animation: fadeIn 0.35s ease-out;
  }

  /*
   * IMPORTANTE: animacao SO com opacity.
   * Nunca usar transform/filter aqui pois criariam um
   * containing block que prende position fixed dos modais
   * renderizados inline dentro de qualquer tela.
   * Ref: design-system.md secoes 1.3 e 15
   */
  @keyframes fadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  .dashboard-content {
    padding: 0 2em;

    h2 {
      font-size: 1.5em;
      margin-bottom: 0.5em;
      color: ${(props) => props.theme?.text || "#e5e7eb"};
    }

    p {
      color: ${(props) => props.theme?.text || "#e5e7eb"};
      opacity: 0.7;
    }
  }
`;
